<template>
	<div v-if="isModalOpen" class="z-backdrop fixed left-0 top-0 h-full w-full outline-none overflow-y-overlay !bg-black/40" ref="backdrop">
		<div class="mx-auto top-0 bottom-0 fixed bg-zt-normal shadow-zt w-full
          xl:h-fit xl:top-[80px] xl:!relative xl:max-w-[624px] xl:rounded-md"
		     :class="[
           { 'overflow-x-hidden overflow-y-scroll': openedModal.name !== 'TabCoupons' },
           window.PHP.visibleAdminBar ? 'top-8 !xl:top-[112px]' : ''
         ]">
			<div class="flex items-center z-50 p-4 font-semibold border-b border-zt-light sticky top-0 bg-zt-normal">
				{{ openedModal.label }}
				<div class="x-close-modal-td" @click="emitter.emit('bettingTipsModalCloseButtonClicked', $event)"></div>
			</div>
			<component :is="openedModal.name" is-betting-tips @close-modal="closeModal"/>
		</div>
	</div>

	<div v-if="window.size.mobile" id="sticky-bar"
       class="container bg-[#1F2733] sticky z-50 mx-auto !py-[13px] border-zt-normal border-b mb-3">
		<div class="flex justify-between items-center px-4 !w-auto">
			<div v-for="tab in tabs" :key="tab.id"
			     @click="openModal(tab)"
			     class="relative !w-auto flex flex-col justify-center items-center zt-hover"
			     :class="{ 'tab-selected': betStore.selectedTab === tab.name }">
        <span class="relative" :class="{ '!z-40': tab.name === 'TabCoupons'}">
          <img :src="'/wp-content/themes/zawodtyper/assets/images/bets_tabs/' + tab.name + '.svg'"
               alt="" width="30" height="30" class="opacity-50" :class="{'!opacity-100': betStore.selectedTab === tab.name}">
	        <span id="redDot" v-if="tab.name === 'TabBets'" class="hidden left-[25px] w-[8px] -top-[3px] h-[8px] absolute rounded-[24px] bg-zt-red flex justify-center">
		        <span id="pinging" class="animate-ping-once w-[8px] h-[8px] rounded-[24px] bg-zt-red"></span>
	        </span>
        </span>
        <div v-if="couponStore.addedBets.length > 0 && tab.name === 'TabCoupons'" class="absolute text-center left-4 -top-2">
          <template v-if="couponStore.addedBets.length === 1">
            <div :key="'red1-' + couponStore.addedBets.length"
                 class="absolute rounded-full bg-zt-red animate-scale-out-5 w-3 h-3 z-40"></div>
            <div :key="'red2-' + couponStore.addedBets.length" class="absolute rounded-full bg-zt-red animate-scale-out-3 w-3 h-3 z-30"></div>
            <div :key="'normal-' + couponStore.addedBets.length" class="absolute rounded-full bg-zt-normal animate-scale-out-4 w-3 h-3 z-30"></div>
          </template>
          <div v-else :key="'red3-' + couponStore.addedBets.length" class="absolute rounded-full bg-zt-red animate-scale-out-2 w-3 h-3 z-40"></div>
          <div :key="'text-' + couponStore.addedBets.length" class="absolute rounded-full bg-zt-red font-semibold text-[8px] w-3 h-3 z-40">
            {{ couponStore.addedBets.length }}
          </div>
        </div>
      </div>
		</div>
	</div>

  <div class="container px-[1px] mx-auto xl:grid xl:grid-cols-12 xl:gap-x-8">
    <div class="xl:col-span-3">
      <left-sidebar v-if="window.size.desktop" :class="{'top-[132px]': window.PHP.visibleAdminBar}"
                    class="sticky top-[100px] left-0 w-[296px] transition-transform duration-[.05s] ease-out"/>
    </div>

    <div id="betting-container"
         :class="{ 'xl:min-h-[1575px]' : betStore.selectedTab === 'TabRankings'}"
         class="xl:col-span-6 xl:col-start-4">
      <div ref="back-arrow" class="overflow-hidden back-arrow cursor-pointer w-fit pl-4 zt-hover xl:pl-0 xl:mt-1.5" style="height: 0"
           @click="changeTab('TabBets')">
        <svg class="inline-block back-arrow mr-3 fill-text" width="21" height="15" viewBox="0 0 21 15">
          <path d="M7.36094 1.13e-05L-0.000782657 7.36173L7.36094 14.7235L8.56328 13.5211L3.22656 8.20548L16.6211 8.20548L16.6211 6.51798L3.22656 6.51798L8.56328 1.20236L7.36094 1.13e-05Z"/>
          <path d="M19.1523 8.20548L20.8398 8.20547L20.8398 6.51797L19.1523 6.51797L19.1523 8.20548Z"/>
        </svg>
        <span class="text-text back-arrow text-[14px] font-medium">Powrót do typów</span>
      </div>
      <Transition name="fade" mode="out-in"
                  @before-enter="setStyleBeforeEnter" @before-leave="setStyleBeforeLeave">
        <KeepAlive>
          <component is-betting-tips :is="betStore.selectedTab"/>
        </KeepAlive>
      </Transition>
    </div>

    <scroll-top v-if="window.size.desktop"
                :analytic-name="'Typy Dnia - Wróć na górę (desktop)'"/>

  </div>
</template>

<script>
import TabBets from '../components/daily_bets_tabs/Bets.vue';
import LeftSidebar from '../components/LeftSidebar.vue';
import RightSidebar from '../components/RightSidebar.vue';
import { useBetStore } from '../stores/BetStore.js';
import utils_mixin from '../mixins/utils_mixin';
import { useCouponStore } from '../stores/CouponStore';
import { defineAsyncComponent } from 'vue';
import ScrollTop from '../components/ScrollTop.vue';

export default {
  name: 'BettingTips',
  inject: ['WP'],
  mixins: [utils_mixin],
  components: {
    ScrollTop,
    LeftSidebar,
    RightSidebar,
    TabBets,
    TabRankings: defineAsyncComponent(() => import('../components/daily_bets_tabs/Rankings.vue')),
    TabPrizes: defineAsyncComponent(() => import('../components/daily_bets_tabs/Prizes.vue')),
    TabRules: defineAsyncComponent(() => import('../components/daily_bets_tabs/Rules.vue')),
    TabSettings: defineAsyncComponent(() => import('../components/settings_tabs/TDSettings.vue')),
    TabCoupons: defineAsyncComponent(() => import('../components/daily_bets_tabs/Coupons.vue')),
  },
  setup() {
    const betStore = useBetStore();
    const couponStore = useCouponStore();
    const tabs = [
      { id: 0, name: 'TabBets', label: 'Typy', query_name: 'typy' },
      { id: 1, name: 'TabRankings', label: 'Ranking', query_name: 'ranking' },
      { id: 2, name: 'TabPrizes', label: 'Nagrody', query_name: 'nagrody' },
      { id: 3, name: 'TabRules', label: 'Zasady', query_name: 'zasady' },
      { id: 4, name: 'TabSettings', label: 'Ustawienia', query_name: 'ustawienia' },
      { id: 5, name: 'TabCoupons', label: 'Twój kupon', query_name: 'kupon' },
    ];
    return { betStore, couponStore, tabs };
  },
  data() {
    return {
      barSticking: false,
	    openedModal: this.tabs[0],
	    isModalOpen: false,
    }
  },
  mounted() {
    this.initializeView();
    if (window.size.mobile) {
      this.setupStickyBar();

      let tabName = 'TabBets';
      let hash = window.location.hash.substring(1);
      const availableTabs = this.betStore.navItems.map(item => item.query_name);
      if (availableTabs.includes(hash)) {
        tabName = this.betStore.getNavItemTabName(hash);
        let urlWithoutHash = window.location.href.substring(0, window.location.href.indexOf('#'));
        window.history.replaceState(null, '', urlWithoutHash);
      }
      let tab = this.tabs.find(item => item.name === tabName);
      this.openModal(tab);
    }
    window.addEventListener('scroll', this.handleScrollEvent);
  },
  methods: {
		openModal(tab) {
			if (tab.name === 'TabBets') {
        window.scrollTo({
		      top: 130,
		      left: 0,
		      behavior: 'smooth'
	      });
				return;
			}
			this.blockScrolling();

      if (this.openedModal.name === 'TabBets' && tab.name !== 'TabBets') {
        window.history.replaceState(null, '',
          `${window.location.href}#${tab.query_name}`);
      } else if (this.openedModal.name !== 'TabBets' && tab.name === 'TabBets') {
        window.history.replaceState(null, '',
          `${window.location.href.substring(0, window.location.href.indexOf('#'))}`);
      } else {
        window.history.replaceState(null, '',
          `${window.location.href.substring(0, window.location.href.indexOf('#') + 1)}${tab.query_name}`);
      }

			this.openedModal = tab;
			this.isModalOpen = true;
		},
    closeModal() {
      window.history.replaceState(null, '',
        `${window.location.href.substring(0, window.location.href.indexOf('#'))}`);
      this.openedModal = this.tabs[0];
      this.isModalOpen = false;
      this.unblockScrolling();
    },
    changeTab(tabName) {
      this.betStore.changeTab(tabName);
      if (window.size.mobile) {
	      window.scrollTo({
		      top: 130,
		      left: 0,
		      behavior: 'instant'
	      });
      }
    },
    setStyleBeforeEnter(el) {
      if (this.$refs['back-arrow'] && this.betStore.selectedTab !== 'TabBets') {
        this.$refs['back-arrow'].style.animation = 'slide-down 0.5s ease forwards';
      }
    },
    setStyleBeforeLeave(el) {
      if (this.$refs['back-arrow'] && this.betStore.selectedTab === 'TabBets') {
        this.$refs['back-arrow'].style.animation = 'slide-up 0.5s ease forwards';
      }
    },
    initializeView() {
      scrollTo(0, 0);
      this.betStore.lastScrollPosition = 0;
    },
    setupStickyBar() {
      this.stickyFollowHeader('sticky-bar', this.WP.user.adminBar, 0);
      this.stickyBar = document.getElementById('sticky-bar');
    },
    handleScrollEvent() {
      setTimeout(() => this.refreshTooltips(), 0);
      if (window.size.mobile) {
        this.toggleStickyBarShadow();
      }
    },
    toggleStickyBarShadow() {
      if (window.pageYOffset > 190) {
        this.stickyBar.classList.add('shadow-[0_0_12px_#000]');
        this.barSticking = true;
      } else {
        this.stickyBar.classList.remove('shadow-[0_0_12px_#000]');
        this.barSticking = false;
      }
    },
    hideTooltip(event) {
      for (const element of event.composedPath()) {
        if (typeof element === 'object' && element !== null && 'getAttribute' in element && element.hasAttributes()) {
          for (const attr of element.attributes) {
            if (attr.name === 'data-tooltip-created') {
              setTimeout(() => {
                let tooltip = Tooltip.getInstance(element);
                tooltip.hide();
              }, 0);
              return;
            }
          }
        }
      }
    }
  },
	computed: {
		newBetsCount() {
			return this.betStore.newBetsCount;
		}
	},
	watch: {
		newBetsCount(newVal, oldVal) {
      if (window.size.desktop) {
        return;
      }

			if (newVal > oldVal) {
				document.getElementById('redDot').classList.remove('hidden');
				document.getElementById('pinging').classList.remove('animate-ping-once');
				setTimeout(() => {
					document.getElementById('pinging').classList.add('animate-ping-once');
				}, 0);
			}
			if (newVal === 0) {
				document.getElementById('redDot').classList.add('hidden');
			}
		}
	}
};
</script>

<style scoped>
.tab-selected {
  @apply after:bg-zt-red after:w-full after:h-[2px] after:absolute after:-bottom-2;
}

.tab-selected-new {
  @apply opacity-100 !important;
  @apply after:bg-zt-red after:h-[2px] after:absolute after:-bottom-1 after:w-[36px];
}

.new-bets {
  @apply after:bg-zt-red after:absolute after:top-0 after:right-0 after:h-2 after:w-2 after:rounded-full
    after:translate-x-1/4 after:-translate-y-1/4;
}

.breadcrumbs {
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  scrollbar-width: none;  /* Firefox */

  &::-webkit-scrollbar {
    display: none;  /* Safari and Chrome */
  }
}
@keyframes ping {
	75%, 100% {
		transform: scale(3);
		opacity: 0;
	}
}
.animate-ping-once {
	animation: ping 2.5s cubic-bezier(0, 0, 0.2, 1);
}
</style>